export default {
  title01: "Current weather",
  title02: "24 hours",
  title03: "View 10-day weather forecast",
  title04: "AQI",
  title05: "See All Information",
  title06: "Sunrise and Sunset",
  title07: "Phase of the Moon",
  title08: "The next full moon",
  title09: "The next new moon",
  title10: "Day",
  title11: "Night",
  title12: "Sunrise",
  title13: "Sunset",
  title14: "Moonrise",
  title15: "Moonset",
  title16: "Source",
  title17: "Start",
  title18: "End",
  title19: "Use current location",
  title20: "Search locations",
  title21: "Feels like",
  title22: "Feels like (shade)",
  title23: "Now",
  title24: "Today",
  title25: "Sun",
  title26: "Mon",
  title27: "Tue",
  title28: "Wed",
  title29: "Thu",
  title30: "Fri",
  title31: "Sat",
  title32: "Loading...",
  title33: "Now",
  title34: "Hourly",
  title35: "Daily",
  title36: "Sun & Moon",
  title37: "Air quality",
  title38: "Contact: xlf550402@gmail.com",
  title39: "Privacy Policy",
  title40: "Copyright © comfortweather.com 2020 – 2026. All Rights Reserved.",
  title41: "Data provided by",
  title42: "High",
  title43: "Low",
  title44: "Accept",
  title45: "Thank you for using ComfortWeather! To better protect your legal rights and interests, please read the ",
  title46: "Privacy Policy",
  title47: " carefully before use.",
  title48: "",
  title49: "Contact: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 – 2026. All Rights Reserved.",
  title51: "Thank you for using 24hweather! To better protect your legal rights and interests, please read the",
  title52: "Your location has changed. Would you like to update it?",
  title53: "Confirm",
  title54: "Cancel",
  title55: "Back",
  title56: "News",
  title57: "Updating weather...",
  title58: "Weather updated",
  title59: "View All",
  title60: "Copyright © mobi321.com 2020 – 2026. All Rights Reserved.",
  title61: "Yesterday",
  title62: "Tomorrow",
  title63: "View 15-day weather forecast",
  title64: "Today's details",
  title65: "Rahu Kaal",
  title66: "Lifestyle Indices",
  title67: "Lifestyle Indices",
  title68: "Next 7 Days Rahu Kaal Timings for",
  title69: "To",
  title70: "to",
  title71: "Air Quality Index",

  title102: "Hard to dry",
  title103: "Slow drying",
  title104: "Dries well",
  title105: "Quick drying",
  title106: "Very fast drying",

  title107: "Not suitable",
  title108: "Modest experience",
  title109: "Good for water fun",
  title110: "Very suitable",
  title111: "Perfect conditions",

  title112: "Supportive to health",
  title113: "Neutral conditions",
  title114: "Slightly higher risk",
  title115: "High risk",
  title116: "At extreme risk",

  title117: "Not suitable",
  title118: "Somewhat suitable",
  title119: "Good for outdoors",
  title120: "Very suitable",
  title121: "Excellent conditions",

  title122: "Very dry conditions",
  title123: "Likely dry",
  title124: "Slightly dry",
  title125: "Not likely dry",
  title126: "Very unlikely dry",

  title127: "Not recommended",
  title128: "Acceptable",
  title129: "Good day",
  title130: "Very good conditions",
  title131: "Ideal conditions",
};
